import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { updateUi } from "../common/actions";
import FinancialReportingSearchForm from "../components/FinancialReporting/FinancialReportingSearchForm";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
    userId: appState.uuid,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (
      uiField: string,
      uiValue: boolean | string | number | KeyValue,
    ) => {
      dispatch(updateUi(uiField, uiValue));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinancialReportingSearchForm);
